/**
 * Totalens etiket i widgettens køb (PurchaseModal). Med oprettelsesgebyr eller et særskilt første
 * træk («træk den 1.») er totalen kundens FØRSTE betaling, ikke planens pris, så den hedder
 * «I alt ved første betaling» som på prissiden (public.pricing.firstPaymentTotalLabel).
 * Uden gebyr og første træk: standardetiketten («Total»).
 */
export function firstPaymentTotalLabel(
  signupFeeDkk: number,
  hasFirstCharge: boolean,
  s: { firstPaymentTotalLabel: string },
): string | undefined {
  return signupFeeDkk > 0 || hasFirstCharge ? s.firstPaymentTotalLabel : undefined;
}
